module.exports = __webpack_public_path__ + "static/media/post07.bf548880.jpg";